import { render } from "./MruResolutionTableMobile.vue?vue&type=template&id=344a8087&scoped=true"
import script from "./MruResolutionTableMobile.vue?vue&type=script&lang=js"
export * from "./MruResolutionTableMobile.vue?vue&type=script&lang=js"

import "./MruResolutionTableMobile.vue?vue&type=style&index=0&id=344a8087&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344a8087"]])

export default __exports__